var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.is_subscribed)?_c('button',{class:_vm.button_class,attrs:{"type":"button"},on:{"click":_vm.subscribe}},[_vm._v("\n    "+_vm._s(_vm.$t('subscribe.button'))+"\n  ")]):_c('h2',{staticClass:"title"},[_c('span',{staticStyle:{"color":"#baff00"}},[_vm._v("\n      "+_vm._s(_vm.$t('subscribe.success'))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }